import View                      from '@widesk-ui/components/View';
import Button                    from '@widesk-ui/components/Button';
import { createPortal }          from 'react-dom';
import { useEffect }             from 'react';
import { useState }              from 'react';
import { observer }              from 'mobx-react-lite';
import currentEditorStore        from '@/TokamapEditor/stores/currentEditorStore';
import Kbd                       from '@/TokamapEditor/ux/Kbd';
import DoorOpenOutlined          from '@/TokamapEditor/ux/icons/DoorOpenOutlined';
import useDesignTokens           from '@/hooks/useDesignTokens';

const OpeningToolBar = observer(() => {
	const tokens = useDesignTokens();
	const mapAdapter = currentEditorStore.get?.mapAdapter;
	const container = mapAdapter?.getContainerElement();
	const [active, setActive] = useState(() => mapAdapter?.isDrawingOpening() ?? false);

	useEffect(() => {
		if (!mapAdapter) return;

		setActive(mapAdapter.isDrawingOpening());

		return mapAdapter.on(event => {
			if (event.type === 'opening:tool-changed') setActive(event.active);
		});
	}, [mapAdapter]);

	if (!active || !mapAdapter || !container) return null;

	return createPortal(
		<View abs absB={16} absL={0} w="100%" flex center zIndex={10} style={{ pointerEvents: 'none', userSelect: 'none' }}>
			<View
				row
				centerV
				gap="md"
				pl={16}
				pr={8}
				py={8}
				br={999}
				bg={tokens.surface.elevated}
				size={13}
				style={{ boxShadow: tokens.shadow.elevated, pointerEvents: 'auto' }}
			>
				<View row centerV gap="xs" bold>
					<DoorOpenOutlined style={{ fontSize: 16, color: tokens.color.primary }} />
					Mode ouverture
				</View>

				<View row centerV gap="sm" size={12} color={tokens.text.secondary}>
					<View row centerV gap="xs"><Kbd>Glisser</Kbd>le long d'un mur : ouvrir</View>
					<View row centerV gap="xs"><Kbd>Clic</Kbd>sur une ouverture : la refermer</View>
				</View>

				<Button onClick={() => mapAdapter.stopDrawingOpening()}>Terminer</Button>
			</View>
		</View>,
		container,
	);
});

export default OpeningToolBar;
